// apps/nos/client/src/utils/types/ingredient.ts

export type IngredientKind = "compound" | "food";

export type IngredientRow = {
  compoundId: string;           // "compound:<id>" | "food:<id>"
  kind: IngredientKind;
  substanceId: number;
  name: string;
  identifiers: {
    inchikey: string | null;
    casPrimary: string | null;
    casExtraCount: number;
    catalogNo: string | null;
  };
  technicalRoles: string[];
  flavorLabels: string[];
  family: { code: string; label: string; color: string } | null;
  // §4.2 of 2026-05-11-current-flask-server-data-design — search row carries
  // the same SubstanceLensInfo shape so the registry can prime on add.
  solubility: "water" | "oil" | "mixture" | null;
  chemClass:  string | null;
  // Phase 3: Δ-loss from flavor_formula_version_viz.ingredient_sort.
  // Negative = adding this compound would reduce loss (good); positive =
  // it would increase loss. Null when no versionId was supplied OR the
  // compound is outside the version's scoped candidate set (e.g. already
  // in the formulation, or not yet covered by the active pin's cache).
  deltaLoss: number | null;
};

export type IngredientPage = {
  items: IngredientRow[];
  nextCursor: string | null;
};

export type FamilyChip = { code: string; label: string; color: string };

export type RoleCounts = {
  // Total count of substances matching ALL current filters → top header.
  total: number;
  // Per-role counts; the role filter is ignored. Each chip reflects what
  // the user would get if they selected that role given other filters.
  counts: Record<string, number>;
  // Count if role were "All" given other filters. Differs from
  // sum(counts) because a substance can have multiple roles.
  roleAllCount: number;
  // Per-kind counts; kind filter ignored. Sum = "All" kind chip count.
  kindCounts: { compound: number; food: number };
  // Per-family counts (keyed by family code/slug); family filter ignored.
  // Sum = "All" family chip count.
  familyCounts: Record<string, number>;
};

export type IngredientFilters = {
  kind: "all" | IngredientKind;
  q: string;
  family: string;
  role: string;
};

export const EMPTY_INGREDIENT_FILTERS: IngredientFilters = {
  kind: "all",
  q: "",
  family: "",
  role: "",
};
